import { isEmpty } from 'fp-ts/Record';
import { Membership } from '@mews-commander/guest-profile';
import { Stack } from '@optimus-web/core';
import { useGuestClassificationsSplit, useGuestClassificationsSplitParams } from '../hooks';
import { GuestClassificationsPopover } from './GuestClassificationsPopover';
import { GuestClassificationTag } from './GuestClassificationTag';
import { LoyaltyMembershipTag } from './LoyaltyMembershipTag';

interface GuestTagsSectionProps extends useGuestClassificationsSplitParams {
    loyaltyMembership: Membership | undefined;
}

export const GuestTagsSection = ({ loyaltyMembership, guestProfileClassifications }: GuestTagsSectionProps) => {
    const { first, second, rest } = useGuestClassificationsSplit({ guestProfileClassifications });

    if (!loyaltyMembership && !first) return null;

    const tags = [
        ...(loyaltyMembership && !(Object.keys(loyaltyMembership).length === 0)
            ? [
                  <LoyaltyMembershipTag
                      programName={loyaltyMembership.program.name}
                      tierName={loyaltyMembership.tier?.name}
                  />,
              ]
            : []),
        ...(!isEmpty(first) ? [<GuestClassificationTag {...first} />] : []),
        ...(!isEmpty(second) ? [<GuestClassificationTag {...second} />] : []),
        ...rest.map((item) => <GuestClassificationTag {...item} />),
    ];

    const visibleTags = tags.slice(0, 2);
    const moreItemsCount = tags.length - visibleTags.length;

    return (
        <Stack wrap spacing="100">
            {visibleTags}
            {moreItemsCount > 0 ? (
                <GuestClassificationsPopover linkCount={moreItemsCount} classifications={tags.slice(2)} />
            ) : null}
        </Stack>
    );
};
